import { RigaDistinta } from './RigaDistinta';
import { VariazioneDaComunicareQtaTaglia } from './VariazioneDaComunicareQtaTaglia'
import { VariazioneRigaDistinta } from '.';

export enum TipoVariazione {
    NUOVA,
    ELIMINATA,
    MODIFICABILE,
}

export interface VariazioneDaComunicare {
    rigaDistinta: RigaDistintaPerComunicazioneVariazione;
    variazioneRigaDistintaQtaTaglia: VariazioneDaComunicareQtaTaglia[];
    tipoVariazione: TipoVariazione;
    valida: boolean;

    idDistintaAppartenenza: string;
    idModelloRiferimento: string;
    variazioniCorrelate: VariazioneDaComunicare[];
    eliminataDaAs400: boolean;
    mostraCorrelate?: boolean;    
}

export interface RigaDistintaPerComunicazioneVariazione {
    id: string;
    indiceRiga: number;
    innerRigaDistinta: InnerRigaDistintaPerComunicazioneVariazione;

    variazioniComunicate?: VariazioneRigaDistinta[];
    statoSincronizzazioneVariazione?: string;
    contieneVariazioniDaValidare?: boolean;
    inAttesaDiSincronizzazione?: boolean;
    richiestaDiInserimento?: boolean;
}

export interface InnerRigaDistintaPerComunicazioneVariazione {
    idParte: string;
    idComponenteBga: string;
    idColoreComponenteBgf: string;
    utilizzo: string;
    codFase: string;
    idDistinta: string;
    unMisuraDiBa: string;
}